import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { PublicSharedService } from './public-shared.services';

@Component({
  selector: 'ngx-file-preview',
  templateUrl: './file-preview.component.html',
  styleUrls: ['./file-preview.component.scss']
})
export class FilePreviewComponent implements OnInit {

  id: string;
  type: string;
  previewFilePath: string;
  previewToken: string;
  isAlertMessageBox: boolean = false; 
  isMasterFileExist: boolean = null;
  isPreviewFileExist: boolean = null;
  loading: boolean = false;
  loadingMessage: string = "Retrieving file…";

  pdfSource: string;
  audioStreamingUrl: string;
  videoStreamingUrl: string;
  photoStreamFile: string;

  constructor(
    private router: Router,
    private location: Location,
    private publicSharedService: PublicSharedService
  ) { 
    this.type = this.publicSharedService.fileType;
    this.previewToken = this.publicSharedService.previewToken;
    this.isPreviewFileExist = false;
   
    this.loading = true;
    this.publicSharedService.GetPreviewFileInfo(this.previewToken).subscribe(response => {
      this.loading = false;
      if(response.status) { 
         this.isPreviewFileExist = true;
         if(this.type == 'VIDEO' ) {
            this.videoStreamingUrl = response.previewUrl;
          }else if(this.type == 'AUDIO') {
            this.audioStreamingUrl = response.previewUrl;
          }else if(this.type == 'DOCUMENT') {
            this.pdfSource = response.previewUrl;
          }else if(this.type == 'PHOTO') {
            this.photoStreamFile = response.previewUrl;
          }
      }else{
        if(response.message == 'FILENOTEXIST' || response.message == 'PREVIEWFILENOTEXIST' ){
          this.isMasterFileExist = false;
        }else{
            this.isPreviewFileExist = false;
        }
      }
    });

  }

  ngOnInit(): void {
  }
  
  back(): void {
    this.location.back();
  }

}
